/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { EvmAddressSummaryInfo } from './EvmAddressSummaryInfo';

export type HumanityTokenTransferInfo = {
    STAT: HumanityTokenTransferInfo.STAT;
    TRXHA: string;
    AG: string;
    UT: number;
    MTH: string;
    BNO: string;
    ADDRSFROMINFO: EvmAddressSummaryInfo;
    ADDRSTOINFO: EvmAddressSummaryInfo;
    VAL: string;
    TRXF: string;
    TRXID: string;
    logIndex?: string;
    TI?: string;
};

export namespace HumanityTokenTransferInfo {

    export enum STAT {
        SUCCESS = 'SUCCESS',
        FAILURE = 'FAILURE',
        PENDING = 'PENDING',
        FAILED = 'FAILED',
        OUT_COMING = 'OUT_COMING',
        IN_COMING = 'IN_COMING',
        ALL = 'ALL',
    }


}

